import React, { FC } from 'react';
import { ArrayInput, useTranslate, SimpleFormIterator, SelectInput, required } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { useExternalSourceTypes } from '~/hooks/externalSources';
import { H3 } from '~/components';

interface ProfileFormProps {
  keyName: string;
}

export const CashCollectionForm: FC<ProfileFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));

  const { data: externalSourceTypesData, isLoading } = useExternalSourceTypes();
  const externalSourceTypes = isLoading
    ? []
    : externalSourceTypesData?.map((type) => ({ id: type, name: type }));

  return (
    <>
      <H3>{t('externalSourceTypesConfig')}</H3>
      <ArrayInput
        source={`${keyName}.externalSourceTypes`}
        label=''
        className={classes.simpleArrayInput}
      >
        <SimpleFormIterator>
          <SelectInput
            allowEmpty
            source={'externalSourceType'}
            label={t('externalSourceType')}
            choices={externalSourceTypes as any}
            className={classes.inputWidth}
            validate={required()}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};
